import Link from "next/link";

import { routes } from "src/shared/routes";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";
import type { TRegistrationCardData } from "src/shared/types/globalStotre.types";

const PLATFORM_TERMS_URL = "https://www.attend.tech/terms-of-use";
const PLATFORM_PRIVACY_URL = "https://www.attend.tech/privacy-policy";

// Generic registration card.
export const REGISTRATION_CARDS: TRegistrationCardData[] = [
  {
    title: "Austin FC Student Offer",
    description: "Log in to view and purchase available student tickets.",
    authRedirectPage: routes.home,
    buttonLabel: "View Available Offers",
  },
];

// Generic grouped FAQ (same shape as the Colorado Rapids / Milwaukee Bucks
// passes). Placeholder copy — swap for team-provided copy when available.
export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [
  {
    question: "What is the Austin FC Student Offer?",
    answer:
      "The Austin FC Student Offer gives eligible students access to Austin FC home matches at a special student price.",
    group: "OVERVIEW",
  },
  {
    question: "How does it work?",
    answer:
      "Once you purchase, you will receive tickets to the eligible home match. Your tickets will be available to manage 3 hours prior to kickoff.",
    group: "OVERVIEW",
  },
  {
    question: "Can I purchase additional tickets?",
    answer:
      "The Student Offer is intended for the registered student. Additional ticket availability may vary by match.",
    group: "OVERVIEW",
  },
  {
    question: "Where will my seats be?",
    answer:
      "Seat locations are assigned based on availability and may vary from match to match.",
    group: "SEAT/TICKET INFORMATION",
  },
  {
    question: "How do I get my tickets?",
    answer:
      "Tickets will be delivered to your account 3 hours prior to kickoff.",
    group: "SEAT/TICKET INFORMATION",
  },
  {
    question: "Can I transfer my tickets?",
    answer:
      "Please contact us if you have questions about attending with a guest or transferring your ticket.",
    group: "OTHER",
  },
  {
    question: "Can I resale my tickets?",
    answer: "No, Student Offer tickets are not allowed to be resold.",
    group: "OTHER",
  },
  {
    question:
      "If I cannot make a match, can I exchange or refund my ticket to that match?",
    answer: "Refunds or exchanges are not available.",
    group: "OTHER",
  },
  {
    question: "Who do I contact with questions?",
    answer:
      "If you have any questions, use the chat button in the bottom corner of the page to reach our support team.",
    group: "OTHER",
  },
];

// New User Registration terms (SeatGeek Program — standard)
export const REGISTRATION_TERMS_AND_CONDITION = () => (
  <>
    By creating an account, you agree to receive account-related notification
    and marketing communication from the Austin FC and you confirm that you have
    read and agree to the platform&apos;s{" "}
    <Link target="_blank" href={PLATFORM_TERMS_URL}>
      Terms &amp; Conditions
    </Link>{" "}
    and{" "}
    <Link target="_blank" href={PLATFORM_PRIVACY_URL}>
      Privacy Policy
    </Link>
    .
  </>
);

// Checkout Purchase terms (standard)
export const TERMS_AND_CONDITION = () => (
  <>
    By checking the box you agree to receive notifications regarding your
    purchase and to the{" "}
    <Link target="_blank" href={PLATFORM_TERMS_URL}>
      Terms &amp; Conditions
    </Link>{" "}
    and{" "}
    <Link target="_blank" href={PLATFORM_PRIVACY_URL}>
      Privacy Policy
    </Link>
    .
  </>
);
